<template>
  <div class="msg-revoke" :class="{ mine: data.mine }">
    <span v-html="processedText" :title="formatTime" @click="onClick"></span>
  </div>
</template>

<script>
import globalWin from '@/utils/globalWin';
import axios from 'axios';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';

export default {
  inject: ['IMSDKType'],
  props: {
    data: Object,
  },
  computed: {
    processedText() {
      const revokeUser = this.data?.extuinInfo?.name || '对方';
      let text = `${revokeUser}撤回了一条消息`;
      if (this.data.mine) {
        text = '你撤回了一条消息';
      }
      if (this.canReedit) {
        text += ' <a href="javascript:void(0)">重新编辑</a>';
      }
      return text;
    },
    formatTime() {
      const date = new Date();
      return date.toLocaleDateString() + date.toLocaleTimeString();
    },
    // 是否支持撤回
    canReedit() {
      const { MSG_TEXT, MSG_LONG_MSG, MSG_MIX } = this.IMSDKType;
      const canReeditTypes = [
        MSG_TEXT,
        MSG_LONG_MSG,
        MSG_MIX,
      ];
      return canReeditTypes.includes(this.data.origin_type) && this.data.revoke_mine;
    },
  },
  methods: {
    async onClick() {
      if (this.canReedit) {
        const content = await this.getReeditContent();
        // 将重新编辑的内容插入输入框
        globalWin.addSendContent(content);
      }
    },
    /**
     * 获取重新编辑内容
     */
    async getReeditContent() {
      const type = this.data.origin_type;
      switch (type) {
        // 文本消息直接返回
        case this.IMSDKType.MSG_TEXT:
          return this.data.content;
        // 混合消息拼接content
        case this.IMSDKType.MSG_MIX:
          return this.data.content.reduce((total, cur) => total + cur.content, '');
        case this.IMSDKType.MSG_LONG_MSG:
          try {
            const longMessage = await this.getLongMesText().catch(() => {
            });
            return longMessage;
          } catch {
            return '';
          }
        default:
          return '';
      }
    },
    // 获取长文本内容
    async getLongMesText() {
      return new Promise((resolve) => {
        if (this.data.previewContent) {
          resolve(this.data.previewContent);
          return;
        }
        if (this.data.compressed) {
          // 如果是SDK通路的被压缩的长文本
          try {
            const longMessage = SDKUtils.downloadAndParseLongText(this.data);
            resolve(longMessage);
            return;
          } catch (ex) {
            resolve('');
          }
        } else {
          SDKUtils.getDownloadUrl(this.data, IMSDK.OBJTYPES.OBJ_LONGTEXT)
            .then((resPath) => {
              if (resPath) {
                // 为什么此处要设置[transformResponse]? —— 因为当发送的文本内容为纯数字是，axios会将其json化，变成了[Infinity]。
                // 因此要强制设置返回值type为string
                // https://github.com/axios/axios/issues/2791#issuecomment-599374457
                axios.get(resPath, {
                  responseType: 'text',
                  transformResponse: [data => data],
                }).then((response) => {
                  if (response.status === 200) {
                    resolve(response.data);
                    return;
                  }
                })
                  .catch(() => {
                    resolve('');
                  });
              } else {
                resolve('');
              }
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.msg-revoke {
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  // margin-left: -40px;
  &.mine {
    margin-left: 0px;
    margin-right: -40px;
  }
  span {
    background: #fff;
    border-radius: 12px;
    color: #B4B8C4;
    padding: 2px 12px;
    display: inline-block;
  }
}

.html-is-pc{
  .msg-revoke span{
    background: #eceef1;
  }
}
.html-is-pc .im-not-in-frame {
  .msg-revoke {
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 0.6);
    &.mine {
      margin-right: 0px;
    }
    span {
      color: rgba(1, 11, 50, 0.41);
      background-color: rgba(36, 56, 97, 0.05);
      border-radius: inherit;
    }
  }
}
</style>
